/* Tapping a card plays its clip with sound: the tap is the user gesture browsers require for unmuted playback. */
(() => {
  const reduceMotion = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  let current = null;

  const initCard = (card) => {
    const video = card.querySelector('video');
    if (!video) return;

    const sync = () => {
      const isPlaying = !video.paused && !video.ended;
      card.toggleAttribute('data-icwu-playing', isPlaying);
      const label = card.getAttribute(isPlaying ? 'data-icwu-label-pause' : 'data-icwu-label-play');
      if (label) card.setAttribute('aria-label', label);
    };

    video.addEventListener('play', () => {
      if (current && current !== video) current.pause();
      current = video;
      sync();
    });

    video.addEventListener('playing', sync);
    video.addEventListener('pause', sync);

    video.addEventListener('ended', () => {
      if (current === video) current = null;
      delete card.dataset.icwuActive;
      try {
        video.currentTime = 0;
      } catch (e) {
        /* some sources reject seeking before metadata loads */
      }
      sync();
    });

    card.addEventListener('click', () => {
      if (!video.paused) {
        video.pause();
        return;
      }

      card.dataset.icwuActive = 'true';
      const played = video.play();
      if (played && typeof played.catch === 'function') {
        played.catch(() => {
          /* Playback refused: fall back to the poster rather than leave a blank video surface. */
          delete card.dataset.icwuActive;
          sync();
        });
      }
    });

    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting && !video.paused) video.pause();
          });
        },
        { threshold: 0.35 }
      );
      observer.observe(card);
    }

    sync();
  };

  const initArrows = (root) => {
    const track = root.querySelector('[data-icwu-track]');
    const prev = root.querySelector('[data-icwu-dir="prev"]');
    const next = root.querySelector('[data-icwu-dir="next"]');
    if (!track || !prev || !next) return;

    const step = () => {
      const item = track.querySelector('.bronte-icwu__item');
      if (!item) return track.clientWidth;
      const gap = parseFloat(getComputedStyle(track).columnGap) || 24;
      return item.getBoundingClientRect().width + gap;
    };

    const sync = () => {
      const max = track.scrollWidth - track.clientWidth - 1;
      const overflows = max > 1;
      prev.disabled = !overflows || track.scrollLeft <= 1;
      next.disabled = !overflows || track.scrollLeft >= max;
    };

    const scrollBy = (direction) => {
      track.scrollBy({
        left: direction * step(),
        behavior: reduceMotion() ? 'auto' : 'smooth',
      });
    };

    prev.addEventListener('click', () => scrollBy(-1));
    next.addEventListener('click', () => scrollBy(1));
    track.addEventListener('scroll', sync, { passive: true });
    window.addEventListener('resize', sync);
    sync();
  };

  const initSection = (root) => {
    if (root.dataset.icwuReady) return;
    root.dataset.icwuReady = 'true';

    initArrows(root);
    root.querySelectorAll('[data-icwu-card]').forEach(initCard);
  };

  const boot = () => document.querySelectorAll('[data-bronte-icwu]').forEach(initSection);

  if (document.readyState !== 'loading') boot();
  else document.addEventListener('DOMContentLoaded', boot);

  document.addEventListener('shopify:section:load', (event) => {
    const root = event.target.querySelector('[data-bronte-icwu]');
    if (root) initSection(root);
  });

  document.addEventListener('shopify:section:unload', (event) => {
    if (current && event.target.contains(current)) {
      current.pause();
      current = null;
    }
  });
})();
